import * as React from 'react';
import LoginStyles from '../Login.module.scss';
import { LoginPageContainer } from '../LoginPageContainer';
import imgEmailConfirmed from '../../assets/images/auth/email-confirmed.svg';
import imgErrorOccurred from '../../assets/images/auth/error.svg';
import { Auth } from 'shared';
import {
  extractErrorMessageKeysFromHttpResponseException,
  localizeErrors,
} from 'shared/utils/response-error-handler';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { ConfirmationMessageWithAction } from './ConfirmationMessageWithAction';
import { useTranslation } from 'react-i18next';

export const EmailConfirmationPage: React.FC = () => {
  const { userId, code } = useParams<{ userId: string; code: string }>();
  const [isLoading, setIsLoading] = React.useState(false);
  const [errors, setErrors] = React.useState<string[]>([]);
  const i18n = useTranslation();

  useEffect(() => {
    const confirm = async () => {
      setIsLoading(true);
      try {
        await Auth.authService().confirmAccount(userId, code);
      } catch (e) {
        const errorMessage = extractErrorMessageKeysFromHttpResponseException(e);
        setErrors(errorMessage);
      } finally {
        setIsLoading(false);
      }
    };

    confirm();
  }, [userId, code]);

  return (
    <LoginPageContainer additionalClass={LoginStyles.confirmationPage} isLoading={isLoading}>
      {errors.length > 0 ? (
        <ConfirmationMessageWithAction
          image={imgErrorOccurred}
          title={i18n.t('Error_General')}
          description={localizeErrors(errors)}
        />
      ) : (
        <ConfirmationMessageWithAction
          image={imgEmailConfirmed}
          title={i18n.t('Login_EmailConfirmed_Title')}
          description={i18n.t('Login_EmailConfirmed_Description')}
        />
      )}
    </LoginPageContainer>
  );
};
